export default __webpack_public_path__ + "static/media/my-news-app-img.e642a5be.png";